import React, { Component } from 'react';

class IconRefresh extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="none"
                viewBox="0 0 25 24"
            >
                <g clipPath="url(#clip0_1512_87564)">
                    <path
                        fill="#fff"
                        fillRule="evenodd"
                        d="M23.433 17.87a8.198 8.198 0 01-.64 1l.77.78a1.171 1.171 0 01-.52 2l-3.91 1a1.16 1.16 0 01-1.42-1.43l.26-.95.8-2.95a1.16 1.16 0 011.95-.52l.39.4c.226-.337.427-.692.6-1.06A9.67 9.67 0 009.503 3a2.25 2.25 0 00-.46-1.74 2 2 0 00-.44-.43 11.76 11.76 0 014.37-.83 12 12 0 0110.46 17.87zm-10.46 3.83a9.44 9.44 0 003.61-.7 2.361 2.361 0 00.39 1.95c.072.1.156.19.25.27a12 12 0 01-14.78-17c.2-.333.41-.667.63-1l-.63-.63a1.16 1.16 0 01.53-2l3.92-1.04a1.26 1.26 0 01.28-.05A1.18 1.18 0 018.323 3l-.13.62-.22.82-.7 2.43a1.16 1.16 0 01-1.94.53l-.27-.27-.28-.28a9.16 9.16 0 00-.57 1.07 9.66 9.66 0 008.76 13.78z"
                        clipRule="evenodd"
                    ></path>
                </g>
                <defs>
                    <clipPath id="clip0_1512_87564">
                        <path
                            fill="#fff"
                            d="M0 0H24V24H0z"
                            transform="translate(.973)"
                        ></path>
                    </clipPath>
                </defs>
            </svg>
        );
    }
}

export default IconRefresh;